import img1 from '../images/slider/slide_1.png';
import img2 from '../images/slider/slide_1.png';
import imgbg1 from '../images/slider/bg_slide_1.png'
import imgbg2 from '../images/slider/bg_slide_1.png'


const heroSliderData = [
    {
        title_1: "Khám phá",
        title_2: "tìm kiếm, trao đổi",
        title_3: "vật phẩm CSGO",
        description: "Nơi mua bán và trao đổi vật phẩm CS: GO",
        img: img1,
        imgbg: imgbg1,
        class:'left'
    },
    {
        title_1: "Khám phá",
        title_2: "tìm kiếm, trao đổi",
        title_3: "vật phẩm CSGO",
        description: "Nơi mua bán và trao đổi vật phẩm CS: GO",
        img: img2,
        imgbg: imgbg2,
        class:'center'
    },
    {
        title_1: "Khám phá",
        title_2: "tìm kiếm, trao đổi",
        title_3: "vật phẩm CSGO",
        description: "Nơi mua bán và trao đổi vật phẩm CS: GO",
        img: img2,
        imgbg: imgbg2,
        class:'right'
    },

]

export default heroSliderData;
